var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#chat_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.735 16.307c-1.063-.074-1.891-.867-1.984-1.928-.103-1.162-.203-2.927-.203-5.379s.1-4.217.203-5.38c.093-1.06.921-1.853 1.984-1.927 1.344-.094 3.491-.193 6.563-.193s5.219.1 6.563.193c1.063.074 1.892.867 1.985 1.928.102 1.162.202 2.927.202 5.379s-.1 4.217-.202 5.38c-.093 1.06-.922 1.853-1.985 1.927-1.25.088-3.197.18-5.936.192L7.924 19.07a.833.833 0 0 1-1.376-.633v-1.993a75 75 0 0 1-2.813-.138Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.006 6.895c.485 0 .855-.002.87-.007q.012-.002 0-.005a27 27 0 0 0-.862-.007H6.591c-.486 0-.855.003-.871.007q-.012.003 0 .005c.016.005.385.007.87.007zM11.184 10.25c.32 0 .564-.003.575-.007q.008-.003 0-.006c-.011-.004-.252-.007-.57-.007H6.293c-.32 0-.564.003-.574.007q-.007.003 0 .006c.01.004.254.006.574.007z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chat_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.298.25h20v20h-20z"
  })))));
};
export default SvgChat;